import { createContext, useContext } from 'react'
import {
  type MappedScheduleItem,
  type ScheduleItemWithConflicts,
  type ScheduleOverlapArgs,
  createScheduleItemDatabase,
} from './scheduleItemStore'
import type { RowItem } from './useFilteredItems'

export type ScheduleItemsContext<T extends RowItem> = {
  data: ScheduleItemWithConflicts[]
  rows: T[]
  getOverlappingSchedules: (args: ScheduleOverlapArgs) => MappedScheduleItem[]
  isLoading: boolean
  search: ReturnType<typeof createScheduleItemDatabase>['search']
  editingTemplateDriverId?: string | null
  editTemplateForDriver?: (id: string | null) => void
}
export const ScheduleItemsContext = createContext<ScheduleItemsContext<RowItem>>({
  data: [],
  rows: [],
  getOverlappingSchedules: () => [],
  isLoading: true,
  search: createScheduleItemDatabase([]).search,
  editingTemplateDriverId: null,
  editTemplateForDriver: (id: string | null) => {},
})
export function useScheduleItems<T extends RowItem>() {
  return useContext(ScheduleItemsContext) as ScheduleItemsContext<T>
}
